import { faCalendarCheck } from '@fortawesome/free-regular-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a calendar check icon.
 *
 * @see Docs https://fontawesome.com/v6/icons/calendar-check?f=classic&s=regular
 */
export const CalendarCheckIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faCalendarCheck} {...props} />;
};
